var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden lg:block w-full bg-grey-lighter rounded-sm font-semibold leading-normal tracking-wide uppercase"},[_c('h3',{staticClass:"py-4 px-4 font-semibold text-base"},[_vm._t("title")],2),_vm._v(" "),_c('ul',{staticClass:"list-reset"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }